// extracted by mini-css-extract-plugin
module.exports = {"zoomIcon":"anatomyEdit_zoomIcon__2cJut","wrapperClass":"anatomyEdit_wrapperClass__15YmQ","iconHover":"anatomyEdit_iconHover__30PtK"};